import Button from './Button';

const OutlineButton = Button.extend`
  border: 1px solid ${(props) => (props.borderColor) ? props.borderColor : '#b4b4b4'};
  background-color: #fff;
  color: #000;
  &:disabled {
    opacity: 0.7;
    &:hover {
      // background-color:  ${(props) => (props.backgroundColor) ? props.backgroundColor : '#442359'};
      color: #000;
    }
  }
  &:hover {
    color: #000;
    background-color: #b4b4b4
  }
`;

export default OutlineButton;



// WEBPACK FOOTER //
// ./app/containers/FastCover/components/Button/OutlineButton.js